export class Movement {
  constructor(public movements: Array<any>,
              public accessoryAmounts: Array<any>) {}
}



// WEBPACK FOOTER //
// /home/jenkins/workspace/production-argos-front/argos/src/app/shared/model/movement.ts